import React from 'react';
import { useProfile } from '../hooks/useProfile';
import AvatarUpload from '../components/profile/AvatarUpload';
import ProfileEditForm from '../components/profile/ProfileEditForm';
import PasswordChangeForm from '../components/profile/PasswordChangeForm';

const Profile: React.FC = () => {
  const { profile, isLoading, error } = useProfile();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (error || !profile) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <p className="text-red-600 text-lg">Error al cargar el perfil</p>
          <p className="text-gray-500 text-sm mt-1">Intenta recargar la página</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Mi Perfil</h1>
        <p className="mt-2 text-sm text-gray-600">
          Administra tu información personal y seguridad
        </p>
      </div>

      {/* Avatar + basic info */}
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex flex-col sm:flex-row items-center gap-6">
          <AvatarUpload
            avatarUrl={profile.avatarUrl ?? null}
            firstName={profile.firstName}
            lastName={profile.lastName}
          />
          <div className="text-center sm:text-left">
            <h2 className="text-xl font-semibold text-gray-900">
              {profile.firstName} {profile.lastName}
            </h2>
            <p className="text-gray-500">{profile.email}</p>
            {profile.companyName && (
              <p className="text-sm text-gray-400 mt-1">{profile.companyName}</p>
            )}
          </div>
        </div>
      </div>

      {/* Profile edit form */}
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Información Personal</h2>
        <ProfileEditForm profile={profile} />
      </div>

      {/* Password change */}
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Cambiar Contraseña</h2>
        <PasswordChangeForm />
      </div>
    </div>
  );
};

export default Profile;
